/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FlagAIcon16Solid = forwardRef('FlagAIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2 3a2 2 0 0 1 2-2h10a1 1 0 0 1 .8 1.6L12.25 6l2.55 3.4A1 1 0 0 1 14 11H4v4a1 1 0 1 1-2 0V3Z" })));
});
